//TODO: 추후 삭제처리

import { useState, useCallback, useEffect, ChangeEvent } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { useNavigate } from 'react-router-dom';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { integerFormatter, getPasswordString } from '@utils/common/formatter';
import { integratedValidator } from '@utils/common/validators';
import { getLocaleValueForFlag } from '@utils/common/language';

const UserManager = () => {
  const { userInfo } = useSelector(({ auth }: RootState) => auth);
  const navigate = useNavigate();

  // state for textInfo
  const [textInfo, setTextInfo] = useState({
    phoneNumber: '',
    userName: '',
    phoneNumber1: '',
    teamName: '',
  });

  // state for passwordForm toggle
  const [passwordToggle, setPasswordToggle] = useState(false);
  // state for password change state
  const [passwordTextObj, setPasswordTextObj] = useState({
    currentPassword: '',
    newPassword: '',
    newPasswordConfirm: '',
  });

  // state for check subscription
  const [subscripeCheck, setSubscripeCheck] = useState(false);

  // useEffect for setTextInfo
  useEffect(() => {
    if (userInfo) {
      const { userName, teamName, phoneNumber, phoneNumber1 } = userInfo;
      console.log('phoneNumber1: ', phoneNumber1);
      setTextInfo({
        phoneNumber: phoneNumber,
        userName: userName,
        phoneNumber1: phoneNumber1.substring(0, 1) === '+' ? phoneNumber1 : '',
        teamName: teamName,
      });
    }
  }, [userInfo]);

  // useCallbacks
  const onChangeTexts = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    setTextInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const onChangePhone1 = useCallback((value) => {
    console.log('value: ', value);
    setTextInfo((prev) => ({
      ...prev,
      phoneNumber1: value,
    }));
  }, []);

  const onChangePasswordTexts = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    setPasswordTextObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  // useCallback for
  const onClickChangePasswordTexts = useCallback(async () => {
    if (passwordToggle) {
      // 토글 버튼이 열렸을때
      if (confirm('Would you want to cancel to change your password?')) {
        // 그냥 토글을 닫고 싶을때
        // 초기화 처리
        setPasswordToggle(false);
        setPasswordTextObj({
          currentPassword: '',
          newPassword: '',
          newPasswordConfirm: '',
        });
        return;
      }

      const { currentPassword, newPassword, newPasswordConfirm } = passwordTextObj;
      const { password, userId } = userInfo;

      if (
        currentPassword.trim().length === 0 ||
        newPassword.trim().length === 0 ||
        newPasswordConfirm.trim().length === 0
      ) {
        return alert('Plz insert empty password text first!');
      } else {
        if (password !== currentPassword.trim()) {
          return alert('Wrong Current Password!');
        } else if (!integratedValidator('password', newPassword.trim())) {
          return alert('Invalid New password');
        } else if (newPassword.trim() !== newPasswordConfirm.trim()) {
          return alert('Not a same new password!');
        } else if (confirm('Do you Want to change password?')) {
          const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', {
            params: { userId: userId, newPassword: newPassword },
          });
          if (status === 200) {
            alert('password Changed!');
          }
        }
      }

      // 초기화 처리
      setPasswordToggle(false);
      setPasswordTextObj({
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
      });
    } else {
      // 토글 버튼이 닫혔을때
      setPasswordToggle(true);
    }
  }, [userInfo, passwordTextObj, passwordToggle]);

  const onClickSave = useCallback(async () => {
    const { userId } = userInfo;
    const { phoneNumber, phoneNumber1, userName, teamName } = textInfo;
    console.log('phoneNumber1: ', phoneNumber1);

    if (phoneNumber.trim().length === 0) {
      return alert('Phone Number is required');
    }
    if (!integratedValidator('phone', phoneNumber)) {
      return alert('Invalid Phone Number');
    }
    if (userName.trim().length === 0) {
      return alert('Your Firstname is required');
    }
    if (phoneNumber1.trim().length === 0) {
      return alert('Phone Number1 is required');
    }
    // TODO: phoneNumber1 유효성 검사 방법 체크!
    // if (!integratedValidator('phone', phoneNumber1)) {
    //   return alert('Invalid Phone Number1');
    // }

    const { data, status } = await axiosDummyInstance.get('/api/commonGetResponse.json', {
      params: { userId, phoneNumber, phoneNumber1, userName, teamName, subscripeCheck },
    });

    if (status === 200) {
      console.log(
        'userId, phoneNumber, phoneNumber1, userName, teamName, subscripeCheck: ',
        userId,
        phoneNumber,
        phoneNumber1,
        userName,
        teamName,
        subscripeCheck
      );
      alert('Successfully Saved');
      navigate('/manager/service/appManager');
    }
  }, [userInfo, textInfo, subscripeCheck, navigate]);

  return (
    <>
      <h2 className="account-tit">User Manager</h2>
      <div className="tb-basic-wrap tb-type-1">
        <div className="tb-basic-inner">
          <table>
            <colgroup>
              <col width="18%" />
              <col width="31%" />
              <col width="20%" />
              <col width="31%" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="col">Email Address</th>
                <td colSpan={3}>
                  <div className="account-email">{userInfo.email}</div>
                </td>
              </tr>
              <tr>
                <th scope="col" rowSpan={2} className="pw-tit">
                  Password
                </th>
                <td colSpan={3}>
                  <div className="pw">
                    <p>{getPasswordString(userInfo.password)}</p>
                    <button type="button" className="btn-s pri" onClick={onClickChangePasswordTexts}>
                      Change Password
                    </button>
                  </div>
                </td>
              </tr>
              {/* 아래의 줄이 보였다 사라졌다 처리 */}
              <tr>
                <td colSpan={3}>
                  {passwordToggle && (
                    <ul className="pw-change">
                      <li>
                        <p className="pw-change-tit">Current Password</p>
                        <label className="ipt">
                          <input
                            type="password"
                            placeholder=""
                            value={passwordTextObj.currentPassword}
                            name="currentPassword"
                            onChange={onChangePasswordTexts}
                          />
                        </label>
                      </li>
                      <li>
                        <p className="pw-change-tit">New Password</p>
                        <label className="ipt">
                          <input
                            type="password"
                            placeholder=""
                            value={passwordTextObj.newPassword}
                            name="newPassword"
                            onChange={onChangePasswordTexts}
                          />
                        </label>
                      </li>
                      <li>
                        <p className="pw-change-tit">New Password confirm</p>
                        <label className="ipt">
                          <input
                            type="password"
                            placeholder=""
                            value={passwordTextObj.newPasswordConfirm}
                            name="newPasswordConfirm"
                            onChange={onChangePasswordTexts}
                          />
                        </label>
                      </li>
                    </ul>
                  )}
                </td>
              </tr>
              <tr>
                <th scope="col">
                  Phone Number
                  <span className="account-star-require">*</span>
                </th>
                <td>
                  <div>
                    <label className="ipt">
                      <input
                        type="text"
                        placeholder=""
                        name="phoneNumber"
                        value={textInfo.phoneNumber}
                        onChange={onChangeTexts}
                      />
                    </label>
                  </div>
                </td>
                <th scope="col">
                  UserName
                  <span className="account-star-require">*</span>
                </th>
                <td>
                  <div>
                    <label className="ipt">
                      <input
                        type="text"
                        placeholder=""
                        value={textInfo.userName}
                        name="userName"
                        onChange={onChangeTexts}
                      />
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="col">
                  Phone Number1
                  <span className="account-star-require">*</span>
                </th>
                <td>
                  <div className="account-phone">
                    <label className="ipt">
                      <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry={getLocaleValueForFlag()}
                        value={textInfo.phoneNumber1}
                        onChange={onChangePhone1}
                      />
                    </label>
                    {/* <img src="/images/dummy/sample-24.png" alt="" />
                    <label className="ipt">
                      <input
                        type="text"
                        placeholder=""
                        value={textInfo.phoneNumber1}
                        name="phoneNumber1"
                        onChange={onChangeTexts}
                      />
                    </label> */}
                  </div>
                </td>
                <th scope="col">Team Name</th>
                <td>
                  <div>
                    <label className="ipt">
                      <input
                        type="text"
                        placeholder=""
                        value={textInfo.teamName}
                        name="teamName"
                        onChange={onChangeTexts}
                      />
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="account-agree">
        <input
          type="checkbox"
          className="ipt-check basic"
          id="checked-5"
          checked={subscripeCheck}
          onChange={() => setSubscripeCheck((prev) => !prev)}
        />
        <label htmlFor="checked-5">I Want to subscripe to newsletters</label>
      </div>
      <div className="account-btn">
        <button type="button" className="btn-s pri" onClick={onClickSave}>
          Save
        </button>
      </div>
    </>
  );
};

export default UserManager;
